/**
 * `kory_ranked_feed`: a per-browser override of the person's New Overview switch (set by an admin,
 * per person or by role, and read from `GET /users/me`). Open `/?kory_ranked_feed=1` (or the
 * styleguide with it) to force the feed on in this browser, `?kory_ranked_feed=0` to force it off.
 * With neither set, the admin's switch decides. The URL is read wherever the gate is checked:
 * Overview (the feed), the tray, and the styleguide's Kory Feed section.
 */

export const KORY_RANKED_FEED_FLAG = "kory_ranked_feed";
const STORAGE_KEY = `kory.flag.${KORY_RANKED_FEED_FLAG}`;

/** This browser's override: true (forced on), false (forced off), or null (follow the admin's switch). */
export function koryRankedFeedOverride(): boolean | null {
  if (typeof window === "undefined") return null;
  try {
    const param = new URLSearchParams(window.location.search).get(KORY_RANKED_FEED_FLAG);
    if (param === "1" || param === "0") window.localStorage.setItem(STORAGE_KEY, param);
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === "1" ? true : stored === "0" ? false : null;
  } catch {
    return null;
  }
}
